export default __webpack_public_path__ + "static/media/shb-logo-letter.2ecb5fcc.svg";